import React from "react";
import { useNavigate } from "react-router-dom";
import { FaUser, FaUserPlus } from "react-icons/fa";
import "../css/TopNavbar.css";
import logo from "../img/logo-kucuk-gold.jpeg";
import PremiumBackground from "../pages/kuyumcu/components/PremiumBackground";


const TopNavbar = () => {
  const navigate = useNavigate();

  return (
    <nav className="top-navbar">

      <div className="top-navbar-inner">

        {/* Sol: Logo + Brand */}
        <div
          className="navbar-brand"
          role="button"
          tabIndex={0}
          onClick={() => navigate("/")}
          onKeyDown={(e) => {
            if (e.key === "Enter") navigate("/");
          }}
        >
          <PremiumBackground/>

          <div className="navbar-logo">
            <img src={logo} alt="Proset" />
          </div>

          <div className="navbar-brand-text">
            <div className="brand-subtitle">Kuyumcu Muhasebe & Stok Yönetimi</div>
          </div>
        </div>

        {/* Sağ: Aksiyonlar */}
        <div className="navbar-actions">
          <button className="navbar-btn navbar-btn-ghost" onClick={() => navigate("/login")}>
            <FaUser className="icon" />
            <span className="btn-text">Giriş Yap</span>
          </button>

          <button className="navbar-btn navbar-btn-primary" onClick={() => navigate("/register")}>
            <FaUserPlus className="icon" />
            <span className="btn-text">Üye Ol</span>
          </button>
        </div>
      </div>
    </nav>
  );
};

export default TopNavbar;
